import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { CustomerType, PrintSiteRef } from '../../../core';

export interface CheckLayoutOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-company-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './company-form.component.html',
  styleUrls: ['./company-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyFormComponent {
  @Input() companyForm!: FormGroup;
  @Input() printSites$: Observable<PrintSiteRef[]> = of([]);
  @Input() customerTypes$: Observable<CustomerType[]> = of([]);
  @Input() saving$: Observable<boolean> = of(false);
  @Input() saveError$: Observable<string | null> = of(null);
  @Input() showResetButton = false;
  @Input() hideCustomerType = false;
  @Input() submitButtonText = 'Save';
  @Input() savingButtonText = 'Saving...';

  @Output() readonly save = new EventEmitter<void>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() readonly cancel = new EventEmitter<void>();
  @Output() readonly formReset = new EventEmitter<void>();

  readonly checkLayoutTypes: CheckLayoutOption[] = [
    { value: 'standard', label: 'Standard' },
    { value: 'detailed', label: 'Detailed' },
    { value: 'tip-credit', label: 'Tip-Credit' },
    { value: 'FAR', label: 'FAR' },
  ];

  onFieldInput(controlName: string, event: Event): void {
    const input = event.target as HTMLInputElement;
    this.companyForm.get(controlName)?.setValue(input.value);
    this.companyForm.get(controlName)?.markAsTouched();
    this.companyForm.get(controlName)?.markAsDirty();
  }

  onNativeCheckboxChange(controlName: string, event: Event): void {
    const input = event.target as HTMLInputElement;
    this.companyForm.get(controlName)?.setValue(input.checked);
    this.companyForm.get(controlName)?.markAsDirty();
  }

  onSave(): void {
    this.save.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onReset(): void {
    this.formReset.emit();
  }
}
